module.exports = __webpack_public_path__ + "img/cb-logo.8f218c2e.png";